import styled from 'styled-components/macro';
import { colorCoreBackground1000, colorCoreBlack900Base, colorCoreGray500, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const BannerStyled = styled(FlexWrapper) `
  color: ${colorCoreBlack900Base};
  border-radius: ${CORNER_RADIUS.m};
  background: ${colorCoreBackground1000};
  border: 1px solid ${colorCoreGray500};
`;
export const BannerHeaderStyled = styled(FlexWrapper) `
  padding: 12px 16px;
  border-bottom: 1px solid ${colorCoreGray500};
`;
export const BannerBodyStyled = styled.div `
  padding: 24px;
  p {
    margin-bottom: 8px;
  }
`;
